import { animationStyles } from "@components/buttons/common/AnimatedDash"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import { smallcapsBold14Styles } from "@constants/typography"
import { DesktopOnly } from "@utils/MediaQuery"
import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  padding-bottom: 24px;
  cursor: pointer;
`

const GatsbyLink = styled(Link)<any>`
  ${({ to }) => (!to.length ? "pointer-events: none" : "cursor: pointer")};
  ${animationStyles}
`

const ImageWrapper = styled.div`
  ${ImageHelperContainer} {
    position: relative;
    width: calc(1.85 / 12 * 100vw);
    max-height: 100px;
    padding: 24px;
    background-color: ${colors.backgroundGray};

    @media ${breakpoints.laptop} {
      &:hover {
        background-color: ${colors.backgroundGrayHover};
      }
    }
  }
`

const Content = styled.div`
  position: absolute;
  top: calc(50% - 18px);
  left: 0;
  align-items: center;
  flex-direction: row;
  display: flex;
  width: 100%;
  padding: 0 24px;
  background: transparent;
  z-index: 999;
`

const Title = styled.div`
  ${smallcapsBold14Styles}
  color: #fff;
`

interface VisualLinkProps {
  className?: string
  image: string
  link: string
  onClick?: () => void
  title: string
}

const DesktopVisualLink = (props: VisualLinkProps) => {
  return props.image ? (
    <DesktopOnly>
      <GatsbyLink to={props.link || ""}>
        <Container className={props.className} onClick={props.onClick}>
          <ImageWrapper>
            <ImageHelper overlay={true} src={props.image} />
          </ImageWrapper>
          <Content>
            <Title>{props.title}</Title>
          </Content>
        </Container>
      </GatsbyLink>
    </DesktopOnly>
  ) : null
}

export default DesktopVisualLink
